import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Icon, Button } from 'Components';
import './NavDesktopFooter.css';


const NavDesktopFooter = (props) => {
  const { t } = useTranslation();
  const { REGION_CONTACT_EMAIL } = useSelector(state => state.appConfig);

  return (
    <div className="nav__desktop__footer">
      <Button
        onClick={() => props.setAppState(prevState => ({
          isTutorialShowing: !prevState.isTutorialShowing,
        }))}
      >
        <Icon icon="info" />
      </Button>
      <a href={`mailto:${REGION_CONTACT_EMAIL}`}>
        <span>{t('nav:Contact Us')}</span>
      </a>
    </div>
  );
};

NavDesktopFooter.propTypes = {
  setAppState: PropTypes.func,
};

export default NavDesktopFooter;



// WEBPACK FOOTER //
// ./src/containers/Nav/NavDesktop/NavDesktopFooter/NavDesktopFooter.jsx